import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getPartyDetails = (state) => {
  
  return axios.get(API + "parties/party-details/"+state+"/",{headers: authHeader(),});
};
const DetailsPartyService = {
    getPartyDetails,
  };
  export default DetailsPartyService;